export const updateAuthentication = authentication => ({
  type: 'UPDATE_AUTHENTICATION',
  payload: authentication,
});
